import * as T from "../../types/constant";
import * as A from "../../types/app";

export const changeTheme = (theme: string): A.ChangeThemeAction => {
  return {
    type: T.CHANGE_THEME,
    payload: {theme},
  };
};
